import React from 'react';
import { Button } from 'react-bootstrap';
import api from '../../services/api';

const PayslipDownload = ({ payslipId }) => {
  const handleDownload = () => {
    api.get(`/payslips/download/${payslipId}`,{
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Payslip_${payslipId}.pdf`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return <Button onClick={handleDownload} variant="secondary">Download Payslip</Button>;
};

export default PayslipDownload;